export default "__VITE_ASSET__4y_dJE5Q__";